import { localStorage } from 'helpers/localStorage'

const DEVICE_ID_KEY = 'push_device_id'
const storage = localStorage()

export const getDeviceId = (): string => {
  let deviceId = storage.getItem(DEVICE_ID_KEY)

  if (!deviceId) {
    deviceId = crypto.randomUUID()
    storage.setItem(DEVICE_ID_KEY, deviceId)
  }

  return deviceId
}

export const clearDeviceId = (): void => {
  storage.removeItem(DEVICE_ID_KEY)
}
